module.exports = __webpack_public_path__ + "static/media/helvetia_logo_fr.db8b6d4e.svg";